"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = require("react");

var _lodash = require("lodash");

var useResizeEvent = function useResizeEvent(_ref) {
  var componentRef = _ref.componentRef,
      _ref$checkParent = _ref.checkParent,
      checkParent = _ref$checkParent === void 0 ? false : _ref$checkParent,
      _ref$observeWidth = _ref.observeWidth,
      observeWidth = _ref$observeWidth === void 0 ? true : _ref$observeWidth,
      _ref$observeHight = _ref.observeHight,
      observeHight = _ref$observeHight === void 0 ? true : _ref$observeHight;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      currentWidth = _useState2[0],
      setWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      currentHeight = _useState4[0],
      setHeight = _useState4[1];

  var checkScreenSize = function checkScreenSize() {
    if (componentRef && componentRef.current) {
      if (checkParent) {
        setWidth(componentRef.current.parentElement.offsetWidth);
        setHeight(componentRef.current.parentElement.offsetHeight);
      } else {
        setWidth(componentRef.current.offsetWidth);
        setHeight(componentRef.current.offsetHeight);
      }
    }
  };

  var handleResize = (0, _lodash.throttle)(function () {
    checkScreenSize();
  }, 500);
  (0, _react.useEffect)(function () {
    checkScreenSize();
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (observeWidth && !observeHight) {
    return currentWidth;
  }

  if (observeHight && !observeWidth) {
    return currentHeight;
  }

  return {
    width: currentWidth,
    height: currentHeight
  };
};

var _default = useResizeEvent;
exports.default = _default;